"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImportCounterGroup = exports.useUpdateCounterGroup = exports.useCreateCounterGroup = exports.useFetchCounterGroups = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const counterGroupsAction_1 = require("./counterGroupsAction");
const useFetchCounterGroups = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const fetchCounterGroupsLoading = (0, react_redux_1.useSelector)((state) => state['counterGroups/fetch'].loading);
    const fetchCounterGroupsError = (0, react_redux_1.useSelector)((state) => state['counterGroups/fetch'].error);
    const fetchCounterGroupsData = (0, react_redux_1.useSelector)((state) => state['counterGroups/fetch'].data);
    const fetchAllCounterGroupsData = (0, react_redux_1.useSelector)((state) => state['counterGroups/fetchAll'].data);
    const fetchCounterGroups = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!isUserLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, counterGroupsAction_1.fetch)(payload));
    });
    const fetchAllCounterGroups = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!isUserLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, counterGroupsAction_1.fetchAll)(payload));
    });
    return {
        fetchCounterGroupsLoading,
        fetchCounterGroupsError,
        fetchCounterGroupsData,
        fetchAllCounterGroupsData,
        fetchCounterGroups,
        fetchAllCounterGroups
    };
};
exports.useFetchCounterGroups = useFetchCounterGroups;
const useCreateCounterGroup = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const createCounterGroupLoading = (0, react_redux_1.useSelector)((state) => state['counterGroups/create'].loading);
    const createCounterGroupError = (0, react_redux_1.useSelector)((state) => state['counterGroups/create'].error);
    const createCounterGroupData = (0, react_redux_1.useSelector)((state) => state['counterGroups/create'].data);
    const createCounterGroup = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, counterGroupsAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to create counter groups");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createCounterGroupLoading,
        createCounterGroupError,
        createCounterGroupData,
        createCounterGroup
    };
};
exports.useCreateCounterGroup = useCreateCounterGroup;
const useUpdateCounterGroup = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const updateCounterGroupLoading = (0, react_redux_1.useSelector)((state) => state['counterGroups/update'].loading);
    const updateCounterGroupError = (0, react_redux_1.useSelector)((state) => state['counterGroups/update'].error);
    const updateCounterGroupData = (0, react_redux_1.useSelector)((state) => state['counterGroups/update'].data);
    const updateCounterGroup = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, counterGroupsAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to update counter groups");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateCounterGroupLoading,
        updateCounterGroupError,
        updateCounterGroupData,
        updateCounterGroup
    };
};
exports.useUpdateCounterGroup = useUpdateCounterGroup;
const useImportCounterGroup = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const importCounterGroupLoading = (0, react_redux_1.useSelector)((state) => state['counterGroups/import'].loading);
    const importCounterGroupError = (0, react_redux_1.useSelector)((state) => state['counterGroups/import'].error);
    const importCounterGroupData = (0, react_redux_1.useSelector)((state) => state['counterGroups/import'].data);
    const importCounterGroup = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, counterGroupsAction_1.importCounterGroups)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to import counter groups");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        importCounterGroupLoading,
        importCounterGroupError,
        importCounterGroupData,
        importCounterGroup
    };
};
exports.useImportCounterGroup = useImportCounterGroup;
